import { render, staticRenderFns } from "./ResultadoExportacaoComError.vue?vue&type=template&id=b57b24bc"
import script from "./ResultadoExportacaoComError.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadoExportacaoComError.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports